import { EditorView } from "@codemirror/view"

/**
 * Extension to handle clipboard events and prevent them from bubbling to window.
 * This prevents window-level event listeners from capturing copy/cut/paste events
 * that should be handled only by the editor.
 */
export const clipboardHandler = EditorView.domEventHandlers({
  copy(event: ClipboardEvent) {
    // Stop event from bubbling to window
    event.stopPropagation()
    // Let CodeMirror handle the copy operation normally
    return false
  },
  
  cut(event: ClipboardEvent) {
    // Stop event from bubbling to window
    event.stopPropagation()
    // Let CodeMirror handle the cut operation normally
    return false
  },
  
  paste(event: ClipboardEvent) {
    // Stop event from bubbling to window
    event.stopPropagation()
    // Let CodeMirror handle the paste operation normally
    return false
  },
})

